// /* Copyright 2024
//  *   __  __                       _           _     _   _            _ _   _
//  *  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  *  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  *  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  *  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//  *
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Moonshot Health Incorporated and its suppliers,
//  * if any.  The intellectual and technical concepts contained
//  * herein are proprietary to Adobe Systems Incorporated
//  * and its suppliers and may be covered by U.S. and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Moonshot Health Incorporated.
//  */

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/hub/v1/call.proto (package msh.trait.hub.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.hub.v1.InitiateCallTrait
 */
export const InitiateCallTrait = proto3.makeMessageType(
  "msh.trait.hub.v1.InitiateCallTrait",
  [],
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.hub.v1.InitiateCallTrait.InitiateCallCommand
 */
export const InitiateCallTrait_InitiateCallCommand = proto3.makeMessageType(
  "msh.trait.hub.v1.InitiateCallTrait.InitiateCallCommand",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "called_by_mobile", kind: "message", T: BoolValue },
    { no: 4, name: "caller_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "InitiateCallTrait_InitiateCallCommand"},
);

/**
 * ----------- Events ----------- //
 *
 * @generated from message msh.trait.hub.v1.InitiateCallTrait.InitiateCallEvent
 */
export const InitiateCallTrait_InitiateCallEvent = proto3.makeMessageType(
  "msh.trait.hub.v1.InitiateCallTrait.InitiateCallEvent",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "InitiateCallTrait_InitiateCallEvent"},
);

